import I18n from 'I18n';
import { Image } from 'foundations-components/transitional/components/Image';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Hoverlay } from 'foundations-components/transitional/components/Hoverlay';
import { View } from 'foundations-components/components/View';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPreviewImageURL, getScreenshotPreviewUrl } from '../utils/contentObjectUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const PreviewImage = ({
  name,
  previewUrl,
  screenshotUrl,
  screenshotUrlLoading
}) => {
  const nameForAlt = name || I18n.text('content-management-details-lib.header.unknownTitle');
  if (screenshotUrlLoading) {
    return /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      justify: "center",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        minHeight: 190
      })
    });
  }
  if (screenshotUrl) {
    return /*#__PURE__*/_jsx(Hoverlay, {
      foregroundContent: /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        justify: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-details-lib.header.previewImage.openPage"
        })
      }),
      href: previewUrl,
      children: /*#__PURE__*/_jsx(View, {
        borderWidth: "200",
        borderStyle: "solid",
        borderColor: "border-tertiary-default",
        children: /*#__PURE__*/_jsx(Image, {
          alt: I18n.text('content-management-details-lib.header.previewImage.previewAlt', {
            name: nameForAlt
          }),
          "data-test-id": "content-preview-image",
          src: screenshotUrl
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    justify: "center",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-details-lib.header.previewImage.missingPreview"
    })
  });
};
export const ContentPreviewScreenshot = ({
  contentObject
}) => {
  const screenshotUrl = getScreenshotPreviewUrl(contentObject);
  const previewUrl = getPreviewImageURL(contentObject);
  const name = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.NAME);
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "content-preview-image-wrapper",
    children: /*#__PURE__*/_jsx(PreviewImage, {
      name: name,
      previewUrl: previewUrl,
      screenshotUrl: screenshotUrl,
      screenshotUrlLoading: false
    })
  });
};